export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = 3